export interface Idea {
  id: number;
  rewrittenEnglishSummary: string;
  category: string;
  createdAt: string;
  likeCount: number;
  status: 'active' | 'dealt_with';
  userHasLiked: boolean;
}

export interface ArchivedIdea {
  id: number;
  rewrittenEnglishSummary: string;
  category: string;
  dealtWithAt: string;
  createdAt: string;
  likeCount: number;
}

export interface FeatureUpdate {
  id: number;
  createdAt: string;
  summary: string;
}

export interface SubmitIdeaRequest {
  originalText: string;
  category: string | null;
}

export interface SubmitIdeaResponse {
  id: number;
  originalText: string;
  rewrittenEnglishSummary: string;
  detectedOriginalLanguage: string;
  category: string;
  createdAt: string;
  likeCount: number;
  status: 'active';
  dealtWithAt: null;
}

export const IDEA_CATEGORIES = [
  'Product Features',
  'Data & Analytics',
  'User Experience',
  'Integration',
  'Performance',
  'Documentation',
  'Other'
] as const;

export type IdeaCategory = typeof IDEA_CATEGORIES[number];
